<template>
  <span class="ml-1 pointer" @click="changeOrder()">
    <span v-if="useState">
      <ArrowOrder :field="this.field" />
    </span>
    <span v-else>
      <font-awesome-icon v-if="order == 'asc'" icon="chevron-up" />
      <font-awesome-icon v-else icon="chevron-down" />
    </span>
  </span>
</template>

<script>
import { state, gettersMap, mutationsMap } from "store/table.js";
import ArrowOrder from "components/Table/ArrowOrder.vue";
export default {
  components: { ArrowOrder },
  props: ["field", "pre_order", "entity", "useState"],
  data: () => ({
    order: "desc",
  }),
  mounted() {
    if (this.pre_order) {
      this.order = this.pre_order;
    }
  },
  methods: {
    changeOrder() {
      if (this.order == "asc") {
        this.order = "desc";
      } else {
        this.order = "asc";
      }
      eventBus.$emit(`orderColumn${this.entity}`, {
        field: this.field,
        order: this.order,
      });
      let order_state = {};
      order_state[this.field] = this.order;
      mutationsMap.setOrder(order_state);
    },
  },
};
</script>
